import './js/refs';
import './js/init';
import './js/notifly-options';
import './js/first-loading';
import './js/render-markup';
import './js/main-page-only/modal';

import './js/search';
import './js/main-page-only/pagination';
import './js/spinner';
import './js/cursor';
import './js/transitionFix';

